import React, { Component } from "react";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as tmxActions from '../Actions/tmxActions';
import { tmxService } from "../Services/TmxService.js";
import TmxUploadForm from "../Components/Tmx/TmxUploadForm";
import { customerService } from "../Services/CustomerService.js";
import { withRouter } from 'react-router';

class TmxFormContainer extends Component {
	constructor(props){
		super(props);
		
		this.saveTmx = this.saveTmx.bind(this);
	}
	
	saveTmx(tmx, description, langPairId) {
		tmxService.updateTmx(this.props.tmx.id, description, tmx)
			.then(() => {return this.props.history.push('/tmxList');})
			.catch(err => {/*console.log(err);*/});
	}
	render() {
//		console.log(this.props);
		return (<div className="content">
					<TmxUploadForm	
						langPairs={this.props.tmx ? this.props.tmx.languagePair : []}
						tmx={this.props.tmx}
						uploadTmx={this.saveTmx}/>
				</div>);
	}
}

function mapStateToProps(state, ownProps) {  
//	console.log('mapStateToProps [TmxFormContainer]: '+JSON.stringify(ownProps));
	return {tmx: state.tmxs.find(tmx => {if(tmx.id == ownProps.match.params.id){ return true;}}), user: state.user}
}

function mapDispatchToProps(dispatch) {  
	return {actions: bindActionCreators(tmxActions, dispatch)}
}

export default connect(mapStateToProps, mapDispatchToProps)(TmxFormContainer);  